(function () {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 15000;

  var overlay, drawer, itemsEl, subtotalEl, titleEl, shipFill, shipText, closeBtn;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  // Bug fix: previously hardcoded '$' regardless of the store's actual
  // currency. Now formats using the currency reported by the AJAX Cart
  // API response (cart.currency, e.g. "PKR"), falling back to the
  // storefront's active currency / USD only if neither is available.
  function money(cents, currencyCode) {
    var amount = cents / 100;
    var currency =
      currencyCode ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol'
      }).format(amount);
    } catch (e) {
      return currency + ' ' + amount.toFixed(2);
    }
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function init() {
    overlay = qs('[data-cart-drawer-overlay]');
    drawer = qs('[data-cart-drawer]');
    if (!drawer) return;

    itemsEl = qs('[data-cart-drawer-items]', drawer);
    subtotalEl = qs('[data-cart-drawer-subtotal]', drawer);
    titleEl = qs('[data-cart-drawer-title]', drawer);
    shipFill = qs('[data-cart-drawer-shipping-fill]', drawer);
    shipText = qs('[data-cart-drawer-shipping-text]', drawer);
    closeBtn = qs('[data-cart-drawer-close]', drawer);

    closeBtn && closeBtn.addEventListener('click', close);
    overlay && overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cart-drawer-trigger]');
      if (trigger) {
        e.preventDefault();
        open();
      }

      var addTrigger = e.target.closest('[data-quick-add-trigger]');
      if (addTrigger && !addTrigger.disabled) {
        e.preventDefault();
        var variantId = addTrigger.getAttribute('data-variant-id');
        if (variantId) addToCart(variantId, 1);
      }

      var qtyBtn = e.target.closest('[data-qty-decrease],[data-qty-increase]');
      if (qtyBtn) {
        var row = qtyBtn.closest('[data-line]');
        var line = parseInt(row.getAttribute('data-line'), 10);
        var qtyLabel = row.querySelector('[data-qty-value]');
        var current = parseInt(qtyLabel.textContent, 10) || 1;
        var next = qtyBtn.hasAttribute('data-qty-increase') ? current + 1 : current - 1;
        changeLine(line, Math.max(0, next));
      }
    });

    // Bug fix (Cart Drawer Unification): the home-grid "Add to Cart" /
    // plus-icon quick-add form in snippets/vesture-product-card.liquid
    // is a plain, unwrapped `{% form 'product', product %}` — it isn't
    // wrapped in the theme's `<product-form-component>`, so it had no
    // AJAX interception at all and fell through to a native browser
    // form submission (full page reload), which is what surfaced
    // Shopify's default plain cart UI instead of our frosted drawer.
    // Intercept it here, add via the AJAX Cart API, and open our own
    // drawer — same as the product-detail flow.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('.va-product-card__quick-add-form, [data-vesture-add-to-cart-form]')) return;

      e.preventDefault();
      var idInput = form.querySelector('input[name="id"]');
      var variantId = idInput && idInput.value;
      if (variantId) addToCart(variantId, 1);
    });

    // Bug fix (Cart Drawer Unification): any OTHER add-to-cart flow in
    // the theme that still goes through the standard
    // `<product-form-component>` (assets/product-form.js) — e.g. the
    // standard product-detail add-to-cart block, quick-add modal, or
    // any future section using the default blocks — dispatches
    // Shopify's standard `shopify:cart:lines-update` event rather than
    // our own `vesture:cart:changed` event. Listening for it here
    // means every add-to-cart trigger in the theme, present and
    // future, opens this one custom drawer instead of relying on
    // Shopify's default `cart-drawer-component` (which is no longer
    // rendered in layout/theme.liquid).
    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (!e || e.action !== 'add') return;

      var refreshAndOpen = function () {
        fetchCart().then(render);
        open();
      };

      if (e.promise && typeof e.promise.then === 'function') {
        e.promise.then(refreshAndOpen).catch(refreshAndOpen);
      } else {
        refreshAndOpen();
      }
    });

    window.addEventListener('vesture:cart:changed', function () {
      fetchCart().then(render);
    });

    fetchCart().then(render);
  }

  function open() {
    if (!drawer) return;
    overlay.hidden = false;
    drawer.hidden = false;
    requestAnimationFrame(function () {
      overlay.classList.add('is-visible');
      drawer.classList.add('is-open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('va-scroll-lock');
  }

  function close() {
    if (!drawer) return;
    overlay.classList.remove('is-visible');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('va-scroll-lock');
    setTimeout(function () {
      overlay.hidden = true;
      drawer.hidden = true;
    }, 320);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        window.dispatchEvent(new CustomEvent('vesture:cart:changed'));
        open();
      });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        window.dispatchEvent(new CustomEvent('vesture:cart:changed'));
      });
  }

  function render(cart) {
    qsa('.va-header__bag-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    if (titleEl) titleEl.textContent = 'Your Bag (' + cart.item_count + (cart.item_count === 1 ? ' Item' : ' Items') + ')';
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price, cart.currency);

    if (itemsEl) {
      itemsEl.innerHTML = '';
      if (cart.items.length === 0) {
        itemsEl.innerHTML = '<p class=\'va-cart-drawer__empty va-eyebrow\'>Your bag is empty</p>';
      }
      cart.items.forEach(function (item, index) {
        var row = document.createElement('div');
        row.className = 'va-cart-item';
        row.setAttribute('data-line', index + 1);
        row.innerHTML =
          '<img src=\'' + item.image + '&width=200\' alt=\'' + escapeHtml(item.product_title) + '\'>' +
          '<div class=\'va-cart-item__info\'>' +
            '<h3>' + escapeHtml(item.product_title) + '</h3>' +
            (item.variant_title ? '<p class=\'va-cart-item__variant\'>' + escapeHtml(item.variant_title) + '</p>' : '') +
            '<div class=\'va-cart-item__qty\'>' +
              '<button type=\'button\' data-qty-decrease aria-label=\'Decrease quantity\'>\u2212</button>' +
              '<span data-qty-value>' + item.quantity + '</span>' +
              '<button type=\'button\' data-qty-increase aria-label=\'Increase quantity\'>+</button>' +
            '</div>' +
          '</div>' +
          '<div class=\'va-cart-item__price\'>' + money(item.final_line_price, cart.currency) + '</div>';
        itemsEl.appendChild(row);
      });
    }

    if (shipFill && shipText) {
      var remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
      if (remaining <= 0) {
        shipFill.style.width = '100%';
        shipText.textContent = 'Free express shipping unlocked';
      } else {
        var pct = Math.min(100, (cart.total_price / FREE_SHIPPING_THRESHOLD) * 100);
        shipFill.style.width = pct + '%';
        shipText.textContent = 'Add ' + money(remaining, cart.currency) + ' more for free express shipping';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
